import React from 'react';
export function About() {
  return <section id="about" className="py-12 md:py-20 bg-white border-t border-gray-100" data-id="element-24">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-25">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-gray-50 rounded-2xl p-6 sm:p-8 md:p-12 border border-gray-100" data-id="element-26">
          <div className="lg:w-1/2" data-id="element-27">
            <h2 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6" data-id="element-28">
              Who Is Behind the Laravel Recruitment Tests?
            </h2>
            <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6" data-id="element-29">
              Certification for Laravel is a community-driven, open-source
              program that validates real-world Laravel skills and experience.
              Our recruitment tests are built by the same experts who create the
              official certification exams.
            </p>
            <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6" data-id="element-30">
              Our exams are shaped and reviewed by a global network of
              professionals — including our Board of Advisors, Exam Committee,
              Exam Reviewers, and Question Contributors — ensuring every test
              reflects real Laravel development practices.
            </p>
            <p className="text-sm sm:text-base text-gray-600 mb-6 sm:mb-8" data-id="element-31">
              We're not just about badges. We're about credibility, opportunity,
              and community — connecting certified developers and trusted
              companies through our Certified Developer Database, Company
              Certification, and Recruitment Tests.
            </p>
            <div className="flex items-center" data-id="element-32">
              <a href="https://certificationforlaravel.com" className="inline-block px-6 py-3 bg-primary text-white rounded-2xl hover:bg-primary/90 transition-colors font-medium" data-id="element-33">
                Learn more about Certification for Laravel
              </a>
            </div>
          </div>
          <div className="lg:w-1/2 w-full" data-id="element-34">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6PTbLW2TZChwCfV3VN7ZnU/Schermafbeelding_2025-10-13_195915.png" alt="Our Exam Committee and Board of Advisors" className="w-full h-auto rounded-lg shadow-md" data-id="element-35" />
          </div>
        </div>
      </div>
    </section>;
}